/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/page/about-us/testimonials.js":
/*!************************************************************!*\
  !*** ./zrc/scripts/sections/page/about-us/testimonials.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n\nconst REVEAL_SELECTOR = '.au-testimonial__content, .au-testimonial__author-name, .au-testimonial__text';\nconst REVEAL_STAGGER_MS = 200;\nclass TestimonialsComponent extends window.HTMLElement {\n  onSlideTransitionStart = () => {\n    if (!this.swiper) {\n      return;\n    }\n    this.clearRevealTimers();\n    this.resetAllSlidesReveal();\n  };\n  onSlideTransitionEnd = () => {\n    if (!this.swiper) {\n      return;\n    }\n    this.playSlideReveal(this.swiper.slides[this.swiper.activeIndex], {\n      reset: false\n    });\n  };\n  connectedCallback() {\n    this.$swiperRoot = this.querySelector('.au-testimonials__swiper');\n    this.revealTimers = [];\n    if (!this.$swiperRoot) {\n      return;\n    }\n    const $pagination = this.$swiperRoot.querySelector('.swiper-pagination');\n    const slideCount = this.$swiperRoot.querySelectorAll('.swiper-slide').length;\n    const autoplayConfig = this.getAutoplayConfig(slideCount);\n    const modules = [swiper__WEBPACK_IMPORTED_MODULE_0__.Pagination];\n    if (autoplayConfig) {\n      modules.push(swiper__WEBPACK_IMPORTED_MODULE_0__.Autoplay);\n    }\n    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__.default(this.$swiperRoot, {\n      modules,\n      slidesPerView: 1,\n      spaceBetween: 20,\n      speed: 400,\n      autoHeight: true,\n      rewind: slideCount > 1,\n      autoplay: autoplayConfig ?? undefined,\n      pagination: $pagination ? {\n        el: $pagination,\n        type: 'bullets',\n        clickable: true\n      } : undefined,\n      on: {\n        slideChangeTransitionStart: this.onSlideTransitionStart,\n        slideChangeTransitionEnd: this.onSlideTransitionEnd\n      }\n    });\n    this.playSlideReveal(this.swiper.slides[this.swiper.activeIndex]);\n  }\n  getAutoplayConfig(slideCount) {\n    if (slideCount <= 1) {\n      return null;\n    }\n    const autoplayEnabled = this.$swiperRoot.dataset.autoplay === 'true';\n    if (!autoplayEnabled) {\n      return null;\n    }\n    const delaySeconds = Number.parseInt(this.$swiperRoot.dataset.delay, 10) || 5;\n    return {\n      delay: delaySeconds * 1000,\n      disableOnInteraction: false,\n      waitForTransition: true\n    };\n  }\n  disconnectedCallback() {\n    this.clearRevealTimers();\n    if (!this.swiper) {\n      return;\n    }\n    this.swiper.off('slideChangeTransitionStart', this.onSlideTransitionStart);\n    this.swiper.off('slideChangeTransitionEnd', this.onSlideTransitionEnd);\n    this.swiper.destroy(true, true);\n    this.swiper = null;\n  }\n  clearRevealTimers() {\n    this.revealTimers.forEach(timerId => {\n      window.clearTimeout(timerId);\n    });\n    this.revealTimers = [];\n  }\n  resetSlideReveal($slide) {\n    if (!$slide) {\n      return;\n    }\n    $slide.querySelectorAll(REVEAL_SELECTOR).forEach($element => {\n      $element.classList.remove('is-revealed');\n    });\n  }\n  resetAllSlidesReveal() {\n    if (!this.swiper) {\n      return;\n    }\n    this.swiper.slides.forEach($slide => {\n      this.resetSlideReveal($slide);\n    });\n  }\n  forceReflow($element) {\n    return $element.offsetWidth;\n  }\n  playSlideReveal($slide) {\n    let {\n      reset = true\n    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    if (!$slide) {\n      return;\n    }\n    this.clearRevealTimers();\n    if (reset) {\n      this.resetAllSlidesReveal();\n      this.forceReflow($slide);\n    }\n    const $elements = [$slide.querySelector('.au-testimonial__content'), $slide.querySelector('.au-testimonial__author-name'), $slide.querySelector('.au-testimonial__text')].filter(Boolean);\n    $elements.forEach(($element, index) => {\n      const timerId = window.setTimeout(() => {\n        $element.classList.add('is-revealed');\n      }, index * REVEAL_STAGGER_MS);\n      this.revealTimers.push(timerId);\n    });\n  }\n}\nif (!window.customElements.get('testimonials-component')) {\n  window.customElements.define('testimonials-component', TestimonialsComponent);\n}\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/sections/page/about-us/testimonials.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"about-us-testimonials": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/page/about-us/testimonials.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;